import { useContext } from "react";
import InputSetupWizardStepsContext from "components/inputs/InputSetupWizard/contexts/InputSetupWizardStepsContext";
const useInputSetupWizardSteps = () => {
  const inputSetupWizardSteps = useContext(InputSetupWizardStepsContext);
  if (!inputSetupWizardSteps) {
    throw new Error("useInputSetupWizardSteps hook needs to be used inside InputSetupWizardContextSteps.Provider");
  }
  return inputSetupWizardSteps;
};
export default useInputSetupWizardSteps;
